import React from 'react';
import { Box, Button, Typography, IconButton } from '@mui/material';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

const CodiSessionList = ({
  groupedSessions,
  currentSessionId,
  onSelect,
  onDelete,
  isClassic,
  showCreateButton = false,
  onCreate
}) => {
  return (
    <>
      {showCreateButton && (
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onCreate}
          sx={{
            mb: 2,
            borderRadius: isClassic ? '4px' : '12px',
            py: 1.5,
            fontWeight: 600,
            boxShadow: '0 4px 12px rgba(74, 144, 226, 0.3)',
            '&:hover': { boxShadow: '0 6px 20px rgba(74, 144, 226, 0.4)', transform: 'translateY(-2px)' }
          }}
        >
          + Neuer Chat
        </Button>
      )}

      {showCreateButton && (
        <Typography variant="caption" color="text.secondary" sx={{ mb: 1, px: 1, fontWeight: 600 }}>
          CHAT-VERLAUF
        </Typography>
      )}

      <Box
        sx={{
          flex: 1,
          overflowY: 'auto',
          '&::-webkit-scrollbar': { width: '6px' },
          '&::-webkit-scrollbar-track': { bgcolor: 'transparent' },
          '&::-webkit-scrollbar-thumb': { bgcolor: 'rgba(0, 0, 0, 0.2)', borderRadius: '3px', '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.3)' } }
        }}
      >
        {groupedSessions.map((group) => (
          <React.Fragment key={`hdr-${group.label}`}>
            <Typography
              variant="caption"
              color="text.secondary"
              sx={{ display: 'block', px: 1, py: 0.5, mt: 1, fontWeight: 600, fontSize: '0.7rem' }}
            >
              {group.label}
            </Typography>
            {group.items.map((session) => {
              const t = new Date(session.updated_at || session.created_at).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
              const title = session.title || 'Unterhaltung';
              const isActive = currentSessionId === session.session_id;
              return (
                <Box
                  key={session.session_id}
                  onClick={() => onSelect && onSelect(session.session_id)}
                  sx={{
                    p: 1.5,
                    mb: 0.5,
                    borderRadius: isClassic ? '4px' : '12px',
                    bgcolor: isActive ? (isClassic ? 'primary.light' : 'rgba(74, 144, 226, 0.1)') : 'transparent',
                    borderLeft: isActive ? '3px solid' : '3px solid transparent',
                    borderColor: isActive ? 'primary.main' : 'transparent',
                    cursor: 'pointer',
                    transition: 'all 0.2s ease-in-out',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    '&:hover': {
                      bgcolor: isActive ? (isClassic ? 'primary.light' : 'rgba(74, 144, 226, 0.15)') : (isClassic ? 'grey.100' : 'rgba(0, 0, 0, 0.04)')
                    }
                  }}
                >
                  <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography
                      variant="body2"
                      sx={{ fontWeight: isActive ? 600 : 400, mb: 0.5, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                      {title}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
                      {t} · {session.total_tokens_total ?? 0} Tokens
                    </Typography>
                  </Box>
                  <IconButton
                    size="small"
                    aria-label="Chat löschen"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete && onDelete(session.session_id);
                    }}
                    sx={{ opacity: 0.6, '&:hover': { opacity: 1 } }}
                  >
                    <DeleteOutlineIcon fontSize="small" />
                  </IconButton>
                </Box>
              );
            })}
          </React.Fragment>
        ))}
      </Box>
    </>
  );
};

export default CodiSessionList;

